
import { Modal } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { ModuleRegistry } from "ag-grid-community";
import { AllCommunityModule } from "ag-grid-community";
import { provideGlobalGridOptions } from "ag-grid-community";
import formatDateWithTimezone from "../../../utils/dateUtils";

ModuleRegistry.registerModules([AllCommunityModule]);
provideGlobalGridOptions({ theme: "legacy" });

const OrderRevisionModal = ({ showRevisionsModal, setShowRevisionsModal, selectedRevisionOrder, timezone }) => {
  const revisionsColumnDefs = [
    { headerName: "ID", field: "id", flex: 1, sortable: true, filter: true, resizable: true },
    { headerName: "Modified By", field: "modified_by", flex: 2, sortable: true, filter: true, resizable: true },
    {
      headerName: "Order Notes", field: "order_notes", flex: 3, sortable: true, filter: true, resizable: true,
      cellRenderer: (params) => params.value ? params.value : <em>No notes</em>
    },
    {
      headerName: "Date Modified", field: "date_modified", flex: 2,
      valueGetter: (p) => formatDateWithTimezone(p.data.date_modified, timezone), sortable: true, filter: true, resizable: true
    },
    {
      headerName: "Revision Type ID", field: "orders_revision_type_id", flex: 1, sortable: true, filter: true, resizable: true,
      cellRenderer: (params) => params.value || "-"
    },
    {
      headerName: "Revision Value", field: "order_revision_value", flex: 1, sortable: true, filter: true, resizable: true,
      cellRenderer: (params) => params.value || "-"
    },
  ];

return (
<Modal
show={showRevisionsModal}
onHide={() => setShowRevisionsModal(false)}
size="xl"
centered
>
<Modal.Header closeButton>
  <Modal.Title>
    {selectedRevisionOrder ? (
      <>Order #{selectedRevisionOrder.id} - Revisions</>
    ) : (
      "Order Revisions"
    )}
  </Modal.Title>
</Modal.Header>
<Modal.Body style={{ height: '400px' }}>
  {selectedRevisionOrder && selectedRevisionOrder.order_revisions && selectedRevisionOrder.order_revisions.length > 0 ? (
    <div className="ag-theme-quartz" style={{ width: "100%", height: "100%" }}>
      <AgGridReact
        rowData={selectedRevisionOrder.order_revisions}
        columnDefs={revisionsColumnDefs}
        defaultColDef={{ sortable: true, filter: true, resizable: true }}
        pagination={true}
        paginationPageSize={10}
      />
    </div>
  ) : (
    <p>No revisions available for this order.</p>
  )}
</Modal.Body>
        </Modal>)};
        export default OrderRevisionModal;